export const resetPageProps = (set) => () => {
  set({
    page: 1,
    sortingField: "submitted_at",
    sortingOrder: true,
    searchField: "",
  });
};
